import { HTMLAttributes } from "react";
import { cn } from "../../../utils/cn";
import styles from "./PChip.module.scss";

const VARIANT_OPACITY: Record<PChipVariant, number> = {
  primary: 0.1,
  alert: 0.3,
  loyalty: 0.15,
  success: 0.3,
  neutral: 0.2,
};

type PChipVariant = "primary" | "alert" | "loyalty" | "success" | "neutral";

export type PChipSize = "lg" | "md" | "sm";

type PChipProps = HTMLAttributes<HTMLDivElement> & {
  variant?: PChipVariant;
  opacity?: number;
  size?: PChipSize;
  hasOutline?: boolean;
};

export const PChip = ({
  variant = "primary",
  opacity,
  size = "lg",
  hasOutline = false,
  children,
  className,
  style,
  ...rest
}: PChipProps) => {
  const defaultOpacity = VARIANT_OPACITY[variant];

  return (
    <div
      {...rest}
      className={cn(
        styles.p_chip,
        styles[size],
        hasOutline && styles.has_outline,
        styles[variant],
        className
      )}
      style={
        {
          // "--p-chip-color": color,
          "--p-chip-opacity": opacity ?? defaultOpacity,
          ...style,
        } as React.CSSProperties
      }
    >
      <span style={{ position: "relative", zIndex: 1 }}>{children}</span>
    </div>
  );
};
